import { render, staticRenderFns } from "./ViewProposal.vue?vue&type=template&id=8410f938&scoped=true&"
import script from "./ViewProposal.vue?vue&type=script&lang=js&"
export * from "./ViewProposal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8410f938",
  null
  
)

export default component.exports